import React from "react";

const BTN_TEXT = {
  cct: '€ 795 – MICGP CCT EXAM PREP PURCHASE',
  ckt: '€ 595 – MICGP CKT EXAM PREP PURCHASE',
};

export const SubscribeButton = ({topic, onClick, title}) => {
  const handleClick = () => {
    onClick(topic);
  };

  return (
    <div>
      {/* <p>{`${(topic.tutorial_type || '').toUpperCase()} OPTION`}</p> */}
      <button className="btn rounded blue purchase-btn" onClick={handleClick}>{title || BTN_TEXT[topic.tutorial_type]}</button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/profile/components/SubscribeButton.js